import { ActivityIndicator, View } from '@ui/atoms';
import SCREENS from '@constants/Screens';
import useCurrentResidenceReservationUrlQuery from '@hooks/queries/useCurrentResidenceReservationUrlQuery';

function ReservationsScreen() {
  const { data: url, isLoading } = useCurrentResidenceReservationUrlQuery();

  if (isLoading) {
    return (
      <View sx={{ flex: 1, justifyContent: 'center', alignItems: 'center' }}>
        <ActivityIndicator size="large" />
      </View>
    );
  }

  if (!url) {
    return null;
  }

  return (
    <iframe
      src={url}
      title="Reservation"
      style={{ flex: 1, border: 'none', width: '100%', height: '100%' }}
      sandbox="allow-scripts allow-same-origin allow-forms allow-popups"
    />
  );
}

ReservationsScreen.screenName = SCREENS.reservations;

export default ReservationsScreen;
